{
  "promoter": {
    "home": {
      "greeting": "Hi, {{name}}",
      "programLine": "{{percent}}% of each agency's paid subscription for its first {{days}} days. Commissions are held {{hold}} days before they can be paid.",
      "suspended": "Your promoter account is paused. New commissions are not being added.",
      "suspendedReason": "Reason: {{reason}}",
      "suspendedNegativeBalance": "money already paid to you came back (a refund or a dispute), so your balance is below zero.",
      "money": {
        "title": "Your money",
        "available": "Available",
        "held": "On hold",
        "paid": "Paid to you",
        "request": "Request payout",
        "requesting": "Requesting…",
        "requested": "Payout requested. We will review it soon.",
        "reasons": {
          "w9_required": "Upload a W-9 and wait for it to be accepted to request a payout.",
          "request_pending": "Your payout request is waiting for review.",
          "nothing_available": "Nothing is available to pay yet."
        }
      },
      "share": {
        "title": "Share your link",
        "body": "Agencies that create their Coreway account from this link are attributed to you.",
        "code": "Your code",
        "link": "Your link",
        "qr": "QR code for your link",
        "downloadQr": "Download QR"
      },
      "agencies": {
        "title": "Your agencies",
        "empty": "No agency has joined with your link yet.",
        "joined": "Joined {{date}}",
        "barStart": "Started {{date}}",
        "barEnd": "Ends {{date}}",
        "barEnded": "Ended {{date}}",
        "progress": "{{filled}} of {{days}} days counted",
        "extended": "Extended {{days}} days",
        "earned": "Earned",
        "barLabel": "Commission days counted for {{name}}",
        "state": {
          "not_paying": "Not paying yet",
          "in_bar": "Earning",
          "bar_done": "Completed",
          "paused_comp": "Paused (free period)"
        },
        "source": {
          "link": "Link",
          "typed": "Code typed",
          "operator": "Added by Coreway"
        }
      },
      "commissions": {
        "title": "Commissions",
        "empty": "No commissions yet.",
        "paidOn": "Invoice paid {{date}}",
        "payableOn": "Payable {{date}}",
        "base": "Base {{amount}}",
        "kind": {
          "commission": "Commission",
          "clawback": "Clawback",
          "restore": "Restored"
        },
        "clawbackReason": "Refund on the invoice paid {{date}}",
        "restoreReason": "Restored on the invoice paid {{date}}",
        "state": {
          "held": "On hold",
          "available": "Available",
          "paid": "Paid",
          "reversed": "Reversed"
        }
      },
      "payouts": {
        "title": "Payouts and requests",
        "empty": "No payouts or requests yet.",
        "payout": "Payout by {{method}}",
        "paidOn": "Paid {{date}}",
        "reference": "Reference {{reference}}",
        "request": "Payout request",
        "requestedOn": "Requested {{date}}",
        "rejected": "Not approved: {{reason}}",
        "method": {
          "ach": "ACH",
          "check": "check",
          "wire": "wire",
          "zelle": "Zelle",
          "other": "other method"
        },
        "status": {
          "pending": "Waiting for review",
          "paid": "Paid",
          "rejected": "Not approved"
        }
      },
      "w9": {
        "title": "W-9 tax form",
        "body": "US tax law requires a W-9 before we pay you. Fill in the IRS form, save it as a PDF and upload it here.",
        "blank": "Get the blank W-9 from irs.gov",
        "choose": "PDF file (10 MB max)",
        "upload": "Upload W-9",
        "uploading": "Uploading…",
        "uploaded": "W-9 received. We will review it.",
        "status": {
          "none": "Not uploaded yet",
          "submitted": "Under review",
          "accepted": "Accepted",
          "rejected": "Not accepted"
        },
        "submittedOn": "Uploaded {{date}}",
        "acceptedOn": "Accepted {{date}}",
        "rejectReason": "Reason: {{reason}}",
        "replace": "Upload a new W-9"
      },
      "documents": {
        "title": "Signed documents",
        "empty": "No signed documents.",
        "item": "Agreement version {{version}}",
        "signedOn": "Signed {{date}}"
      }
    }
  }
}
